<template>
  <div
    v-if="seatsExceeded && isUserAdmin"
    class="seats-exceeded-banner"
  >
    <div class="seats-exceeded-banner__inner">
      <img
        class="seats-exceeded-banner__icon"
        src="/img/renova-dashboard/icons/error.svg"
        alt="warning"
      />
      <p class="seats-exceeded-banner__text body-text">
        <strong>{{ $t('subscription.seatsExceededBannerLead', { used: usedCount, total: totalCount }) }}</strong>
        {{ $t('subscription.seatsExceededBannerBody', { over: overCount }) }}
      </p>
      <BaseButton
        class="seats-exceeded-banner__cta"
        :is-small="true"
        @click="goToAddTeam"
      >
        {{ $t('subscription.seatsExceededBannerCta') }} →
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { USER_ROLES } from '@/store/modules/user';
import BaseButton from '@/views/RenovaDashboard/components/ui-kit/Buttons/BaseButton';
import licenseMixin from '@/mixins/licenseMixin';

export default {
  name: 'SeatsExceededBanner',
  components: { BaseButton },
  mixins: [licenseMixin],
  computed: {
    ...mapGetters(['userRole']),
    isUserAdmin() {
      return this.userRole === USER_ROLES.ADMIN;
    },
    // Counts come from the same subscriptions payload the backend computes
    // seatsExceeded from, so these are always in sync with the flag.
    usedCount() {
      return this.user?.subscriptions?.sales_hub?.usedCount ?? 0;
    },
    totalCount() {
      return this.user?.subscriptions?.sales_hub?.usersCount ?? 0;
    },
    overCount() {
      return Math.max(0, this.usedCount - this.totalCount);
    },
  },
  methods: {
    goToAddTeam() {
      if (this.$route.path !== '/admin/operators') {
        this.$router.push('/admin/operators');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Positioning belongs to PlatformBanners, which stacks this with the platform-alert strips and
// measures the total height the page has to be pushed down by. This is a plain block now.
.seats-exceeded-banner {
  background: #FFF4CC;
  border-bottom: 1px solid #E6D48F;
  padding: 10px 24px;
}

.seats-exceeded-banner__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 100%;
}

.seats-exceeded-banner__icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.seats-exceeded-banner__text {
  color: #4A3B00;
  margin: 0;
  text-align: center;

  strong {
    font-weight: 600;
  }
}

.seats-exceeded-banner__cta {
  flex-shrink: 0;
  margin-left: 16px;
}
</style>
